export const getCssVariable = (variableName: string): string => {
  const root = document.documentElement;
  return getComputedStyle(root).getPropertyValue(variableName).trim();
};
